import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ILiveLectureConfig {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  status?: boolean;
  title?: string;
  title_text_color?: string;
  title_highlight_color?: string;
  component_background_color?: string;
  day_section_color?: string;
  day_text_color?: string;
  view_button_text_color?: string;
  view_button_bg_color?: string;
  view_button_active_bg_color?: string;
  view_button_active_text_color?: string;
  active_bar_color?: string;
  navigate_button_color?: string;
  left_navigate_icon?: string;
  right_navigate_icon?: string;
  button_icon?: string;
  button_text?: string;
  button_text_color?: string;
  button_bg_color?: string;
  event_color?: string;
  event_text_color?: string;
  tooltip_color?: string;
  tooltip_text_color?: string;
  description?: string;
}

export async function createLiveLectureConfig(payload: Partial<ILiveLectureConfig>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.LIVE_LECTURE_CONFIG.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateLiveLectureConfig(id: number, payload: Partial<ILiveLectureConfig>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.LIVE_LECTURE_CONFIG.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

